import { useField } from "formik";
import {
  DebugForm,
  DisplayFormErrors,
  InputField,
  VerticalForm,
} from "melco-shared-logic";
import { FullWidthSpace } from "melco-ui";
import { useTranslation } from "react-i18next";
import { useState } from "react";
import { MachineList } from "../machine/MachineList";
import { AddMachineDrawer } from "../machine/AddMachineDrawer";
import runes from "runes2";

export const DisplayMachineGroupDetailForm: React.FC = () => {
  const { t } = useTranslation();

  const [{ value: machines }] = useField<any[]>("machine_list");

  console.log(machines);

  const [isDrawerOpen, setDrawerOpen] = useState(false);

  return (
    <VerticalForm>
      <DisplayFormErrors />

      <FullWidthSpace direction="vertical" size="middle">
        <InputField
          count={{
            show: true,
            max: 12,
            strategy: (txt) => runes(txt).length,
            exceedFormatter: (txt, { max }) =>
              runes(txt).slice(0, max).join(""),
          }}
          name="name"
          label={t("reporting.machinegroups.details.form.name")}
        />
        <MachineList setDrawerOpen={setDrawerOpen} />
        <AddMachineDrawer
          isDrawerOpen={isDrawerOpen}
          setDrawerOpen={setDrawerOpen}
        />
      </FullWidthSpace>

      {false && <DebugForm />}
    </VerticalForm>
  );
};
